import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Grid, Row, Panel, Accordion } from 'react-bootstrap';
import "./users.css";
import { Popup } from 'devextreme-react/popup';
import notify from 'devextreme/ui/notify';
import { TextBox } from 'devextreme-react';
import DataGrid, {
    Column, ColumnChooser, ColumnFixing, Sorting, Scrolling, Format, FilterRow, Paging, Selection,
    HeaderFilter,
    FilterPanel
} from 'devextreme-react/data-grid';
import Box, { Item } from 'devextreme-react/box';
import { Button } from 'devextreme-react';
import UserDetailCell from './detailCell.jsx';
import UserLoginCell from './userLoginCell.jsx';
import Navigation from '../navigation/navigation.jsx';

//import { withNavigation } from "react-navigation";
//import { useIsFocused } from '@react-navigation/native';


export default class Position extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userItems: [],
            allClients: [],
            popupVisible: false,
            selectedUsers: [],
            newClient: null,
            confirmButtonDisabled: true,
            removeButtonVisible: false,
            confirmRemoveVisible: false,
            adminEditPopupVisible: false,
            adminLogin: '',
            adminFirstName: '',
            adminLastName: '',
            adminPatronymic: '',
            adminPassword: '',
            adminConfirmPassword: '',
            visibleToControlForManager: true
        };

        this.onAddClientClick = this.onAddClientClick.bind(this);
        this.hideAddClient = this.hideAddClient.bind(this);
        this.hideAdminEdit = this.hideAdminEdit.bind(this);
        this.addClient = this.addClient.bind(this);
        this.addAdmin = this.addAdmin.bind(this);

        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.onClientSelectionChanged = this.onClientSelectionChanged.bind(this);

        this.removeSelectedUsers = this.removeSelectedUsers.bind(this);
        this.onRemoveButtonClick = this.onRemoveButtonClick.bind(this);
        this.onConfirmRemoveClick = this.onConfirmRemoveClick.bind(this);
        this.onCancelRemoveClick = this.onCancelRemoveClick.bind(this);
        this.hideConfirmRemove = this.hideConfirmRemove.bind(this);
        this.onAddAdminClick = this.onAddAdminClick.bind(this);
        this.onConfirmAddAdminClick = this.onConfirmAddAdminClick.bind(this);

        this.onAdminLoginChanged = this.onAdminLoginChanged.bind(this);
        this.onAdminFirstNameChanged = this.onAdminFirstNameChanged.bind(this);
        this.onAdminLastNameChanged = this.onAdminLastNameChanged.bind(this);
        this.onAdminPatronymicChanged = this.onAdminPatronymicChanged.bind(this);
        this.onAdminPasswordChanged = this.onAdminPasswordChanged.bind(this);
        this.onAdminConfrimPasswordChanged = this.onAdminConfrimPasswordChanged.bind(this);
        this.refreshVisibleToControlForManager = this.refreshVisibleToControlForManager.bind(this);


    }

    onAdminLoginChanged(e) {
        this.setState({ adminLogin: e.value });
    }

    onAdminFirstNameChanged(e) {
        this.setState({ adminFirstName: e.value });
    }

    onAdminLastNameChanged(e) {
        this.setState({ adminLastName: e.value });
    }

    onAdminPatronymicChanged(e) {
        this.setState({ adminPatronymic: e.value });
    }

    onAdminPasswordChanged(e) {
        this.setState({ adminPassword: e.value });
    }

    onAdminConfrimPasswordChanged(e) {
        this.setState({ adminConfirmPassword: e.value });
    }

    onConfirmAddAdminClick() {
        this.addAdmin();
    }

    addAdmin() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        var adminData = {
            login: this.state.adminLogin,
            firstName: this.state.adminFirstName,
            lastName: this.state.adminLastName,
            patronymic: this.state.adminPatronymic,
            password: this.state.adminPassword,
            confirmPassword: this.state.adminConfirmPassword
        };

        fetch('api/main/AddAdmin', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(adminData)
        })
            .then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.hideAdminEdit();
                this.refreshData();
            });
    }

    hideAdminEdit() {
        this.setState({ adminEditPopupVisible: false });
    }

    onAddAdminClick() {
        this.setState({ adminEditPopupVisible: true });
    }

    onSelectionChanged({ selectedRowsData }) {
        if (selectedRowsData.length > 0) {
            this.setState({
                selectedUsers: selectedRowsData,
                removeButtonVisible: true
            });
        }
        else {
            this.setState({
                selectedUsers: [],
                removeButtonVisible: false
            });
        }
    }

    hideConfirmRemove() {
        this.setState({ confirmRemoveVisible: false });
    }

    onRemoveButtonClick() {
        this.setState({ confirmRemoveVisible: true });
    }

    onConfirmRemoveClick() {
        this.removeSelectedUsers();
    }

    onCancelRemoveClick() {
        this.hideConfirmRemove();
    }

    onClientSelectionChanged({ selectedRowsData }) {
        if (selectedRowsData.length > 0) {
            this.setState({
                newClient: selectedRowsData[0], confirmButtonDisabled: false
            });
        }
        else {
            this.setState({
                newClient: null, confirmButtonDisabled: true
            });
        }
    }

    componentDidMount() {
        this.refreshData();

    }

    removeSelectedUsers() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        var operationData = {
            list: []
        };

        for (var i = 0; i < this.state.selectedUsers.length; i++) {
            operationData.list.push(this.state.selectedUsers[i].userId);
        };

        fetch('api/main/RemoveUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(operationData)
        })
            .then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.hideConfirmRemove();
                this.refreshData();
            });
    }

    refreshData() {
        var tokenKey = "accessToken";
        var saveToken = sessionStorage.getItem("saveToken")
        var token
        if (saveToken && saveToken !== "") {
            token = saveToken
            sessionStorage.setItem(tokenKey, token)
            sessionStorage.removeItem("saveToken")
        } else {
            token = sessionStorage.getItem(tokenKey);
        }

        fetch('api/main/UserList', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ userItems: data });
            });
        this.refreshVisibleToControlForManager();
    }


    refreshVisibleToControlForManager() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);
        fetch('api/main/GetVisibleToControlForManager', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ visibleToControlForManager: data });
            });
    }

    onAddClientClick() {

        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('api/main/ClientList', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ allClients: data, popupVisible: true, confirmButtonDisabled: true });
            });

    }

    addClient() {
        if (this.state.newClient) {

            var tokenKey = "accessToken";

            var token = sessionStorage.getItem(tokenKey);

            fetch('api/main/AddClient', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(this.state.newClient)
            })
                .then(response => response.json())
                .then(data => {
                    this.refreshData();
                    this.hideAddClient();
                    notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                });
        }
    }
    hideAddClient() {
        this.setState({
            popupVisible: false
        });
    }

    render() {
        return (
            <div>
                <Grid fluid className="positionGrid">
                    <Row>
                        <Col lg={12}>
                            <Button
                                className="toolboxButton"
                                text={'Новый клиент'}
                                type={'default'}
                                width={200}
                                onClick={this.onAddClientClick}
                                visible={this.state.visibleToControlForManager}
                            />
                            <Button
                                className="toolboxButton"
                                text={'Новый администратор'}
                                type={'default'}
                                width={200}
                                onClick={this.onAddAdminClick}
                                visible={this.state.visibleToControlForManager}
                            />

                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Panel header="Список пользователей">
                                <DataGrid
                                    dataSource={this.state.userItems}
                                    onSelectionChanged={this.onSelectionChanged}
                                    allowColumnReordering={true}
                                    allowColumnResizing={true}
                                    columnAutoWidth={true}
                                    hoverStateEnabled={true}
                                    showColumnLines={false}
                                    showRowLines={true}
                                    showBorders={false}>
                                    <Selection
                                        mode={'multiple'}
                                        selectAllMode={'allPages'}
                                        showCheckBoxesMode={this.state.visibleToControlForManager == true ? 'onClick' : 'none'}                                    
                                    />
                                    <HeaderFilter visible={true} />
                                    <FilterRow visible={true} />
                                    <FilterPanel visible={false} />
                                    <Column
                                        dataField={'login'}
                                        caption={'Логин'}>
                                    </Column>
                                    <Column
                                        dataField={'role'}
                                        caption={'Роль'}>
                                    </Column>
                                    <Column
                                        dataField={'fullName'}
                                        caption={'Наименование клиента'}
                                        >
                                    </Column>
                                    <Column
                                        dataField={'lastName'}
                                        caption={'Фамилия'}
                                        visible={false}>
                                    </Column>
                                    <Column
                                        dataField={'firstName'}
                                        caption={'Имя'}
                                        visible={false}                                    >
                                    </Column>
                                    <Column
                                        dataField={'patronymic'}
                                        caption={'Отчество'}
                                        visible={false}                                    >
                                    </Column>
                                    <Column
                                        dataField={'isActive'}
                                        caption={'Активен'}>
                                    </Column>
                                    <Column
                                        dataField={'lastEntry'}
                                        caption={'Дата последнего входа'}
                                        >
                                    </Column>
                                    <Column
                                        dataField={'managerName'}
                                        caption={'Менеджер'}>
                                    </Column>
                                    <Column
                                        caption={''}
                                        visible={this.state.visibleToControlForManager}
                                        cellRender={UserDetailCell}>
                                    </Column>      
                                    <Column
                                        caption={''}
                                        cellRender={UserLoginCell}>
                                    </Column>  
                                </DataGrid>
                            </Panel>
                        </Col>
                    </Row>
                </Grid>

                <Popup
                    className={'popup'}
                    visible={this.state.adminEditPopupVisible}
                    onHiding={this.hideAdminEdit}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title={'Добавить администратора'}
                    width={600}
                    height={'auto'}
                >
                    <Grid fluid>
                        <Row>
                            <Col lg={12}>
                                <Box className="detailLine"
                                    direction={'row'}
                                    width={'100%'}
                                    height={'auto'}>
                                    <Item
                                        ratio={0}
                                        baseSize={160}>
                                        <div className="testClass">
                                            <div className="verticalContent"><span className="dx-icon-user"></span> Логин: </div>
                                        </div>
                                    </Item>
                                    <Item
                                        ratio={1}>
                                        <TextBox value={this.state.adminLogin} placeholder="Задайте логин" className="detailTextBox"
                                            onValueChanged={this.onAdminLoginChanged} valueChangeEvent={'keyup'}
                                        />
                                    </Item>                                    
                                </Box>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Box className="detailLine"
                                    direction={'row'}
                                    width={'100%'}
                                    height={'auto'}>
                                    <Item
                                        ratio={0}
                                        baseSize={160}>
                                        <div className="testClass">
                                            <div className="verticalContent"><span className="dx-icon-check"></span> Фамилия: </div>
                                        </div>
                                    </Item>
                                    <Item
                                        ratio={1}>
                                        <TextBox value={this.state.adminLastName} placeholder="Фамилия" className="detailTextBox"
                                            onValueChanged={this.onAdminFirstNameChanged} valueChangeEvent={'keyup'}
                                        />
                                    </Item>
                                </Box>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Box className="detailLine"
                                    direction={'row'}
                                    width={'100%'}
                                    height={'auto'}>
                                    <Item
                                        ratio={0}
                                        baseSize={160}>
                                        <div className="testClass">
                                            <div className="verticalContent"><span className="dx-icon-check"></span> Имя: </div>
                                        </div>
                                    </Item>
                                    <Item
                                        ratio={1}>
                                        <TextBox value={this.state.adminFirstName} placeholder="Имя" className="detailTextBox"
                                            onValueChanged={this.onAdminLastNameChanged} valueChangeEvent={'keyup'}
                                        />
                                    </Item>
                                </Box>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Box className="detailLine"
                                    direction={'row'}
                                    width={'100%'}
                                    height={'auto'}>
                                    <Item
                                        ratio={0}
                                        baseSize={160}>
                                        <div className="testClass">
                                            <div className="verticalContent"><span className="dx-icon-check"></span> Отчество: </div>
                                        </div>
                                    </Item>
                                    <Item
                                        ratio={1}>
                                        <TextBox value={this.state.adminPatronymic} placeholder="Отчество" className="detailTextBox"
                                            onValueChanged={this.onAdminPatronymicChanged} valueChangeEvent={'keyup'}
                                        />
                                    </Item>
                                </Box>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Box className="detailLine"
                                    direction={'row'}
                                    width={'100%'}
                                    height={'auto'}>
                                    <Item
                                        ratio={0}
                                        baseSize={160}>
                                        <div className="testClass">
                                            <div className="verticalContent"><span className="dx-icon-key"></span> Пароль: </div>
                                        </div>
                                    </Item>
                                    <Item
                                        ratio={1}>
                                        <TextBox value={this.state.adminPassword} placeholder="Задайте пароль" className="detailTextBox" mode={'password'} 
                                            onValueChanged={this.onAdminPasswordChanged} valueChangeEvent={'keyup'}
                                        />
                                    </Item>
                                </Box>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Box className="detailLine"
                                    direction={'row'}
                                    width={'100%'}
                                    height={'auto'}>
                                    <Item
                                        ratio={0}
                                        baseSize={160}>
                                        <div className="testClass">
                                            <div className="verticalContent"><span className="dx-icon-key"></span> Подтверждение: </div>
                                        </div>
                                    </Item>
                                    <Item
                                        ratio={1}>
                                        <TextBox value={this.state.adminConfirmPassword} placeholder="Подтвердите пароль" className="detailTextBox" mode={'password'} 
                                            onValueChanged={this.onAdminConfirmPasswordChanged} valueChangeEvent={'keyup'}
                                        />
                                    </Item>
                                </Box>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <div className="confirmButtons">
                                    <Button
                                        className="confirmButton"
                                        text={'Добавить'}
                                        type={'default'}
                                        width={120}
                                        onClick={this.onConfirmAddAdminClick}
                                    />
                                    <Button
                                        className="confirmButton"
                                        text={'Отмена'}
                                        type={'default'}
                                        width={120}
                                        onClick={this.hideAdminEdit}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </Popup>

                <Popup
                    className={'popup'}
                    visible={this.state.popupVisible}
                    onHiding={this.hideAddClient}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title={'Добавить клиента'}
                    width={900}
                    height={'auto'}
                >
                    <div>
                        <Grid fluid>
                            <Row>
                                <Col lg={12}>
                                    <div className="helpBlock">
                                        <span className="helpIcon dx-icon-tips"></span>
                                        <div className="helpText">
                                            В списке представлены все клиенты, находящиеся в соответствующем справочнике Бинокля.
                                            </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <DataGrid
                                        dataSource={this.state.allClients}
                                        onSelectionChanged={this.onClientSelectionChanged}
                                        allowColumnReordering={true}
                                        allowColumnResizing={true}
                                        columnAutoWidth={true}
                                        selection={{ mode: 'single' }}
                                        hoverStateEnabled={true}
                                        showColumnLines={false}
                                        height={500}
                                        showRowLines={true}
                                        showBorders={false}>
                                        <HeaderFilter visible={true} />
                                        <FilterRow visible={true} />
                                        <FilterPanel visible={false} />
                                        <Column
                                            dataField={'fullName'}
                                            caption={'Наименование клиента'}>
                                        </Column>

                                        <Column
                                            dataField={'inn'}
                                            caption={'ИНН'}
                                            visible={false}                                        >
                                        </Column>
                                        <Column
                                            dataField={'phone'}
                                            caption={'Телефон'}>
                                        </Column>
                                        <Column
                                            dataField={'managerName'}
                                            caption={'Менеджер'}>
                                        </Column>
                                        <Paging defaultPageSize={10} />
                                    </DataGrid>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="confirmButtons">
                                        <Button
                                            className="confirmButton"
                                            text={'Добавить'}
                                            type={'default'}
                                            disabled={this.state.confirmButtonDisabled}
                                            width={120}
                                            onClick={this.addClient}
                                        />
                                        <Button
                                            className="confirmButton"
                                            text={'Отмена'}
                                            type={'default'}
                                            width={120}
                                            onClick={this.hideAddClient}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </Popup>
                <Popup
                    className={'popup'}
                    visible={this.state.confirmRemoveVisible}
                    onHiding={this.hideNewDocument}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title={'Подтверждение операции'}
                    width={400}
                    height={'auto'}
                >
                    <div>
                        <Grid fluid>
                            <Row>
                                <Col lg={12}>
                                    <div>Удалить выбранных пользователей ({this.state.selectedUsers.length})?</div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="confirmButtons">

                                        <Button
                                            className="confirmButton"
                                            text={'Отмена'}
                                            type={'default'}
                                            width={120}
                                            onClick={this.onCancelRemoveClick}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </Popup>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./App/containers/users/users.jsx